module.exports = __webpack_public_path__ + "static/media/NokiaPureHeadline_Lt.2cb2263e.ttf";